import API from "@/config/api";
import { useQuery } from "@tanstack/react-query";

export type SubdomainValidation = {
  subdomain: string;
  isValid: boolean;
  isReserved: boolean;
};

export function useValidateSubdomain(subdomain: string | null) {
  const normalized = subdomain?.trim().toLowerCase() ?? "";

  return useQuery<SubdomainValidation>({
    queryKey: ["subdomain-validation", normalized],
    queryFn: async () => {
      const { data } = await API.main.get(
        `/subdomains/validate/${encodeURIComponent(normalized)}`,
      );

      return data;
    },
    enabled: normalized.length >= 1,
    staleTime: 60_000,
  });
}
